import Box from 'components/UI/Box/Box';
import PropTypes from 'prop-types';

const MenuSwitch = ({
  options = [],
  selected = '',
  onChange,
}) => {
  return (
    <Box className='mb-4' padding='none'>
      <div className='flex justify-between'>
        {options.map((option) => (
          <div
            key={option.value}
            className={`w-1/2 flex items-center justify-center gap-1 py-2 cursor-pointer border-b-2 transition-colors duration-500 ${selected === option.value ? 'border-primary' : 'border-transparent'}`}
            onClick={() => onChange(option.value)}
          >
            <span>{option.label}</span>
            {option.notification && (
              <span className='bg-primary text-white rounded-full w-[22px] h-[22px] flex items-center justify-center text-xs'>{option.notification}</span>
            )}
          </div>
        ))}
      </div>
    </Box>
  );
};

MenuSwitch.propTypes = {
  options: PropTypes.array.isRequired,
  selected: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default MenuSwitch;
